import {React, useEffect} from "react";
import "./ProjectSkeleton.scss";

function Skel({ width, height, strong, circle }) {
  return (
    <div
      className={`custom-skel ${strong ? "custom-skel--strong" : ""} ${
        circle ? "circle" : ""
      }`}
      style={{ width, height }}
      aria-hidden="true"
    />
  );
}

export default function ProjectSkeleton() {
   useEffect(() => {
    document.body.classList.add("anim-sync");
    // trigger synchronized start after render
    const t = setTimeout(() => {
      document.body.classList.replace("anim-sync", "anim-sync-start");
    }, 50);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="project-skeleton">
      {/* Top bar */}
      <div className="skel-topbar">
        <Skel width={1300} height={75} strong />
      </div>
      <div className="skel-pill" style={{display:"flex", gap:"12px"}}>
        <Skel width={100} height={35} strong  borderRadius={999}/>
        <Skel width={100} height={35} strong  borderRadius={999}/>
        <Skel width={100} height={35} strong  borderRadius={999}/>
      </div>

      {/* Table skeleton rows */}
      <div className="skel-table">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="skel-row">
            <Skel width="90%" height={40} />
            <Skel width="70%" height={40} />
            <Skel width="80%" height={40} />
            <Skel width="60%" height={40} />
          </div>
        ))}
      </div>
    </div>
  );
}
